








import { ImageContent, NewsRenderModel } from "@/services/news/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ImageRender extends Vue {
    @Prop() private news!: NewsRenderModel;
    @Prop() private active!: boolean;

    reload = false;
    reloadComponent = 0;

    // lifecycle hooks
    created() {
    }

    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0 && this.renderModel.duration) {
            return setTimeout(
                this.setNextNews,
                this.renderModel.duration * 1000
            );
        }
    }

    get renderModel(): ImageContent {
        return this.news.content as ImageContent;
    }

    setNextNews() {
        this.$emit("setNextNews");
    }

    navigateTo(url: string) {
        window.open(url);
    }
}
